import { render, staticRenderFns } from "./FourPup.vue?vue&type=template&id=49b2b8eb&scoped=true"
import script from "./FourPup.vue?vue&type=script&lang=js"
export * from "./FourPup.vue?vue&type=script&lang=js"
import style0 from "./FourPup.vue?vue&type=style&index=0&id=49b2b8eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b2b8eb",
  null
  
)

export default component.exports